import 'file?name=[name].[ext]!./favicon.ico';
import 'babel-polyfill';
import React from 'react';
import ReactDom from 'react-dom';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import routes from './routes';
import { Provider } from 'react-redux';
import store from './js/store';
import { initialFetch } from './js/initialFetch';
import { startNotificationActionCreator } from './js/actions/externallyTriggeredActionCreators';

const history = syncHistoryWithStore(browserHistory, store);
startNotificationActionCreator(store);

initialFetch();

ReactDom.render(
    <Provider store={store}>
        <Router history={history} routes={routes} />
    </Provider>, 
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.jsx